export default __webpack_public_path__ + "static/media/Menu.7bcac031.svg";